export default __webpack_public_path__ + "static/media/Group8395.56955b37.svg";